import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client, clientFormData, BASE_URL } from '../api/client';
import { getThunkName, printThunkName, updateThunkName } from './base';

export const thunkPerformanceRecapApi = 'api/rekap-capaian-perkin';
export const slicePerformanceRecapName = 'rekap-capaian-perkin';
export const thunkPrintResult = 'cetak';

export const getPerformanceRecap = createAsyncThunk(thunkPerformanceRecapApi, async (params = '', { rejectWithValue }) => {
  try {
    const response = await client.get(BASE_URL + `${thunkPerformanceRecapApi}?${params}`, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const downloadPerformanceRecap = createAsyncThunk(printThunkName(thunkPerformanceRecapApi), async (params = '', { rejectWithValue }) => {
  try {
    const response = await client.get(BASE_URL + `${thunkPerformanceRecapApi}/${thunkPrintResult}?${params}`, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const PerformanceRecapSlice = createSlice({
  name: slicePerformanceRecapName,
  initialState: {
    get: {
      data: [],
      status: 'idle',
      message: '',
      error: '',
      pagination: {},
    },
    download: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
  },
  reducers: {
    reset: (state) => {
      state.download = {
        data: {},
        status: 'idle',
        message: '',
        error: '',
      };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getPerformanceRecap.pending, (state) => {
        state.get.data = [];
        state.get.status = 'loading';
        state.get.message = '';
        state.get.error = '';
        state.get.pagination = {};
      })
      .addCase(getPerformanceRecap.fulfilled, (state, action) => {
        state.get.data = action.payload.data;
        state.get.status = 'succeeded';
        state.get.message = action.payload.message;
        state.get.error = '';
        state.get.pagination = action.payload.meta;
      })
      .addCase(getPerformanceRecap.rejected, (state, action) => {
        state.get.data = [];
        state.get.status = 'failed';
        state.get.message = action.payload
          ? action.payload.message
          : 'Request gagal';
        state.get.error = action.payload && action.payload.error
          ? action.payload.error
          : action.error.message;
        state.get.pagination = {};
      })
      .addCase(downloadPerformanceRecap.pending, state => {
        state.download.data = {};
        state.download.status = 'loading';
        state.download.message = '';
        state.download.error = '';
      })
      .addCase(downloadPerformanceRecap.fulfilled, (state, action) => {
        state.download.data = action.payload.data;
        state.download.status = 'succeeded';
        state.download.message = action.payload.message;
        state.download.error = '';
      })
      .addCase(downloadPerformanceRecap.rejected, (state, action) => {
        state.download.data = {};
        state.download.status = 'failed';
        state.download.message = action.payload.message;
        state.download.error = action.payload.error;
      });
  },
});

export const { reset } = PerformanceRecapSlice.actions;
export default PerformanceRecapSlice.reducer;
